import axios from 'axios';
import {getApiToken} from 'modules/authentication/utils';
import {fireAndForget, refreshTokenAndRetry, apiCallInProgress} from 'modules/api/actions';
import {API_URL} from 'root/config';

const apiMiddleware = store => next => action => {

    console.log('Is this an api action?', action);
    if (!action.payload || !action.payload.apiCall) {
        return next(action);
    }

    console.log('found a call to send to the API');
    const {endpoint, method, actions, data, failOn401, context = {}, baseUrl = API_URL} = action.payload.apiCall;

    console.log('api action payload', action.payload.apiCall);

    if (typeof endpoint !== 'string') {
        throw new Error('Expected an endpoint URL.');
    }
    if (!actions || typeof actions !== 'object' || !actions.request || !actions.error) {
        throw new Error('Expected request and error types on the types object.');
    }

    if (!actions.success) {
        actions.success = fireAndForget;
    }

    let accessToken = getApiToken();
    const headers = {
        "Cache-Control": "no-cache, no-store",
        Expires: 0
    };
    if (accessToken) {
        headers.Authorization = 'Bearer ' + accessToken;
    }

    store.dispatch(actions.request(context));

    try {
        const requestConfig = {
            url: endpoint,
            baseURL: baseUrl || API_URL,
            method,
            data,
            headers,
        };

        store.dispatch(apiCallInProgress(true));

        axios.request(requestConfig).then(
            response => {
                store.dispatch(actions.success(response.data, response.headers.toJSON(), context));
            },
        ).catch(
            error => {
                // if this is due to an expired token, refresh it and retry
                if (error.response && error.response.status == 401 && headers.Authorization && !failOn401) {
                    store.dispatch(refreshTokenAndRetry(endpoint, method, data, actions, context));
                } else {
                    console.log('API error:', error);
                    store.dispatch(actions.error(error, context));
                }
            }
        ).finally(() => {
            store.dispatch(apiCallInProgress(false));
        })

    } catch (e) {
        console.log('Error creating the request:', e);
        store.dispatch(actions.error(e, context));
    }

    return next(action);
};

export default apiMiddleware;
